import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import {
  VariantModel,
  VariantSpecsCategoryModel,
} from '../../models/VariantModel';
import ModelWalkStore from '../../stores/ModelWalkStore';
import { formatMoney } from 'accounting';
import offset from 'document-offset';

interface ModelWalkHeaderState {
  showHeader: boolean;
}

interface ModelWalkHeaderProps {
  store: ModelWalkStore;
  currentIndex: number;
  hasNext: boolean;
  hasPrev: boolean;
  next: Function;
  prev: Function;
}

@observer
class ModelWalkHeader extends React.Component<
  ModelWalkHeaderProps,
  ModelWalkHeaderState
> {
  startTriggerEl = null;
  endTriggerEl = null;
  get currentVariants(): VariantModel[] {
    const { currentIndex, store } = this.props;
    const { variants, breakpoint, showSedan, showVariantGrouping, modelName } =
      store;
    const currentVariants = [];
    let variantsList = [];

    if (showVariantGrouping && modelName.toLowerCase() === 'wrx') {
      if (showSedan) {
        variantsList = variants.filter(
          (v) => v.variantType == 'Sedan' && !v.hideFromModelWalk
        );
      } else {
        variantsList = variants.filter(
          (v) => v.variantType == 'Sportswagon' && !v.hideFromModelWalk
        );
      }
    } else {
      variantsList = variants.filter((v) => !v.hideFromModelWalk);
    }

    if (!breakpoint.isMobile) {
      //Curr
      if (typeof variantsList[currentIndex] !== 'undefined')
        currentVariants.push(variantsList[currentIndex]);

      //Next
      if (typeof variantsList[currentIndex + 1] !== 'undefined')
        currentVariants.push(variantsList[currentIndex + 1]);

      //Next Next
      if (typeof variantsList[currentIndex + 2] !== 'undefined')
        currentVariants.push(variantsList[currentIndex + 2]);
    } else {
      if (typeof variantsList[currentIndex] !== 'undefined')
        currentVariants.push(variantsList[currentIndex]);
    }

    return currentVariants;
  }

  get headerHeight(): number {
    return this.props.store.breakpoint.isMobile ? 53 : 81;
  }

  constructor(props: ModelWalkHeaderProps) {
    super(props);
    this.state = {
      showHeader: false,
    };

    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (!this.startTriggerEl) return;
    const currState = this.state.showHeader;
    const buffer = 150;
    let showHeader =
      window.pageYOffset > offset(this.startTriggerEl).top - buffer;

    if (this.endTriggerEl && showHeader) {
      if (
        window.pageYOffset >
        offset(this.endTriggerEl).top + this.endTriggerEl.offsetHeight
      )
        showHeader = false;
    }

    if (showHeader !== currState) {
      this.setState({ showHeader });
    }
  }

  componentDidMount() {
    this.startTriggerEl = document.getElementById('modelWalk__headerWrap');

    let endTrigger = document.querySelectorAll('.specs__category');
    if (endTrigger.length)
      this.endTriggerEl = endTrigger[endTrigger.length - 1];
  }

  render() {
    const { hasNext, hasPrev, prev, next, store, currentIndex } = this.props;
    const { showSedan, showVariantGrouping, modelName } = store;
    let totalVariants = store.variants.filter(
      (v) => !v.hideFromModelWalk
    ).length;
    if (showVariantGrouping && modelName.toLowerCase() === 'wrx') {
      if (showSedan) {
        totalVariants = store.variants.filter(
          (v) => v.variantType == 'Sedan' && !v.hideFromModelWalk
        ).length;
      } else {
        totalVariants = store.variants.filter(
          (v) => v.variantType == 'Sportswagon' && !v.hideFromModelWalk
        ).length;
      }
    }

    return (
      <div id="modelWalk__headerWrap" className="modelWalk__headerWrap">
        <div
          className={`modelWalk__header ${
            this.state.showHeader ? 'modelWalk__header--show' : ''
          }`}
        >
          <div className="modelWalk__headerInner container">
            {this.currentVariants.map((variant: VariantModel, i: number) => {
              return (
                <div
                  className={`modelWalk__headerCol ${
                    this.currentVariants.length <= 2
                      ? 'modelWalk__headerCol--half'
                      : ''
                  }`}
                  key={`modelWalk__headerCol${i}`}
                >
                  <div className="modelWalk__headerColValue">
                    <h3 className="h3 modelWalk__headerTitle">{variant.name}</h3>
                    {variant.canBuyOnline && (
                      <div
                        onClick={() =>
                          this.props.store.showDetailedPricing(variant)
                        }
                        className={`modelWalk__headerPricing inlineLoader ${
                          variant.rdp ? '' : 'inlineLoader--loading'
                        }`}
                      >
                        <span className="inlineLoader__loader" />
                        From:
                        <div className="modelWalk__headerPrice">
                          {formatMoney(variant.mlp, {
                            symbol: '$',
                            precision: 0,
                          })}{' '}
                          MLP
                          <i className="icon icon--info" />
                        </div>
                        <div className="modelWalk__headerPrice">
                          {formatMoney(variant.rdp, {
                            symbol: '$',
                            precision: 0,
                          })}{' '}
                          RDP
                          <i className="icon icon--info" />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}

            {store.breakpoint.isMobile ? (
              <div className="modelWalk__headerControls">
                <div
                  className={`modelWalk__headerControl modelWalk__headerControl--prev ${
                    hasPrev ? '' : 'modelWalk__headerControl--disabled'
                  }`}
                  onClick={() => prev()}
                />
                <div
                  className={`modelWalk__headerControl modelWalk__headerControl--next ${
                    hasNext ? '' : 'modelWalk__headerControl--disabled'
                  }`}
                  onClick={() => next()}
                />
                <div className="modelWalk__headerControlStatus">
                  {currentIndex + 1} of {totalVariants}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default ModelWalkHeader;
